import styled from 'styled-components';

export const ApplicationOnboardingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

export const TagBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: #6c757d;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  min-height: 32px;
  min-width: 186px;
  background-color: #ffffff;
  border-radius: 8px;
  gap: 10px;
  margin-bottom: 8px;
  padding: 8px 14px;
  width: fit-content;
`;

export const DescriptionSection = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  margin-top: 32px;
  margin-bottom: 24px;
`;
